import { motion } from 'framer-motion';
import clsx from 'clsx';

type Kind =
  | 'question'
  | 'answer'
  | 'warning'
  | 'translation'
  | 'term'
  | 'observation'
  | 'recall';

const META: Record<Kind, { label: string; tone: string; icon: string }> = {
  question:    { label: 'Вопрос',     tone: 'border-accent/40 bg-accent/[0.08] text-ink-1',          icon: '?' },
  answer:      { label: 'Ответ',      tone: 'border-cyan/40 bg-cyan/[0.07] text-ink-1',              icon: '!' },
  warning:     { label: 'Внимание',   tone: 'border-danger/45 bg-danger/[0.08] text-ink-1',          icon: '⚠' },
  translation: { label: 'Перевод',    tone: 'border-success/40 bg-success/[0.07] text-ink-1',        icon: '⇄' },
  term:        { label: 'Термин',     tone: 'border-white/15 bg-white/[0.04] text-ink-1',            icon: '≡' },
  observation: { label: 'Наблюдение', tone: 'border-white/12 bg-white/[0.03] text-ink-2',            icon: '👁' },
  recall:      { label: 'Из прошлого',tone: 'border-warning/40 bg-warning/[0.06] text-ink-1',        icon: '⟲' },
};

export type SuggestionItem = {
  id: string;
  kind: Kind;
  title: string | null;
  body: string;
  trigger: string | null;
  ts: number;
};

type Props = {
  item: SuggestionItem;
};

export function SuggestionCard({ item }: Props) {
  const m = META[item.kind];
  return (
    <motion.div
      layout
      initial={{ y: 20, opacity: 0, scale: 0.96 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ type: 'spring', stiffness: 320, damping: 28 }}
      className={clsx(
        'rounded-3xl border backdrop-blur-xl px-4 py-3 shadow-soft',
        m.tone,
      )}
    >
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider opacity-80">
        <span className="size-5 grid place-items-center rounded-full bg-white/10 text-[12px]">
          {m.icon}
        </span>
        <span>{m.label}</span>
        <span className="ml-auto text-ink-3">
          {Math.floor(item.ts / 1000)}c
        </span>
      </div>
      {item.title && (
        <div className="mt-1 font-medium text-[15px]">{item.title}</div>
      )}
      <p className="text-[14px] leading-snug mt-1 whitespace-pre-wrap">
        {item.body}
      </p>
      {item.trigger && (
        <div className="mt-2 text-[11px] text-ink-3 italic">
          ↳ {item.trigger}
        </div>
      )}
    </motion.div>
  );
}
